import ajax from "../utils/ajax";

export const participantData = {
  get: () => ajax.get("/api/participant/"),
  post: (payload) => ajax.post("/api/participant/", payload),
  put: (id, payload) => ajax.put(`/api/participant/${id}/`, payload),
};
